import { ref, readonly } from 'vue';

// Shared state across all instances
const audio = new Audio('/sounds/cart_expiring.mp3');
const primed = ref(false);

/**
 * Composable for audio notification management using Composition API
 * @returns {Object} Audio notification methods and state
 */
export function useAudioNotification() {
  /**
   * Prime the audio for playback (required for autoplay policies)
   */
  const primeAudio = () => {
    if (primed.value) return;

    audio.volume = 0;
    audio.play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
        primed.value = true;
      })
      .catch((err) => {
        console.log('[Audio] Priming failed:', err);
      });
  };

  /**
   * Play the primed audio notification
   * @param {Object} siteSettings - Site settings object
   */
  const playPrimedAudio = (siteSettings = {}) => {
    const times = parseInt(siteSettings.cart_expiration_play_sound_times) || 1;
    
    if (!primed.value || siteSettings.cart_expiration_play_sound != 1) {
      console.log('[Audio] Not primed yet or playback disabled by site settings.');
      return;
    }

    audio.volume = 1.0;
    let playCount = 0;
    
    const playSound = () => {
      audio.play()
        .then(() => {
          playCount++;
          if (playCount < times) {
            audio.onended = playSound;
          } else {
            audio.onended = null;
          }
        })
        .catch((err) => {
          console.log('[Audio] Playback failed:', err);
        });
    };
    
    playSound();
  };

  return {
    primeAudio,
    playPrimedAudio,
    isPrimed: readonly(primed)
  };
}
